import { createSlice } from '@reduxjs/toolkit';
import { fetchPendingRequests, approvePendingRequest, denyPendingRequest } from '../thunks/pendingRequestsThunks.js';

const initialState = {
    list: [],
    maxPageNumber: 0,
    loading: false,
    error: null,
    requestStatus: 0,
    requestId: null,
};

const pendingRequestsSlice = createSlice({
    name: 'pendingRequests',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPendingRequests.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = false;
                state.error = null;
            })
            .addCase(approvePendingRequest.fulfilled, (state, action) => {
                const { approvedRequestId, approvedRequestStatus } = action.payload;
                state.list = state.list.filter((pendingRequest) => pendingRequest.id !== approvedRequestId);
                state.loading = false;
                state.requestId = approvedRequestId;
                state.requestStatus = approvedRequestStatus;
            })
            .addCase(denyPendingRequest.fulfilled, (state, action) => {
                const { deniedRequestId, deniedRequestStatus } = action.payload;
                state.list = state.list.filter((pendingRequest) => pendingRequest.id !== deniedRequestId);
                state.loading = false;
                state.requestId = deniedRequestId;
                state.requestStatus = deniedRequestStatus;
            })
            .addMatcher(
                (action) =>
                    [
                        fetchPendingRequests.pending.type,
                        approvePendingRequest.pending.type,
                        denyPendingRequest.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchPendingRequests.rejected.type,
                        approvePendingRequest.rejected.type,
                        denyPendingRequest.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.error;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default pendingRequestsSlice.reducer;
